(function () {
  var API = '/apps/paix';

  function initArcade(root) {
    if (!root || root.dataset.pxReady) return;
    root.dataset.pxReady = '1';

    var items = Array.prototype.slice.call(root.querySelectorAll('[data-px-item]'));
    var skipBtn = root.querySelector('[data-px-skip]');
    var soundBtn = root.querySelector('[data-px-sound]');
    var soundLabel = soundBtn && soundBtn.querySelector('.px-arcade__sound-label');
    var gameLink = root.querySelector('[data-px-game]');
    var loggedIn = root.dataset.customer === '1';
    var selected = 0;
    var bootTimer = null;

    function store(kind, key, val) { try { window[kind].setItem(key, val); } catch (e) {} }
    function read(kind, key) { try { return window[kind].getItem(key); } catch (e) { return null; } }
    function gameOpen() { return !!root.querySelector('.px-game'); }
    function esc(s) { var d = document.createElement('div'); d.textContent = String(s); return d.innerHTML; }
    /* While the game is open, typing in any text field (e-mail, name, search) must reach the field, not the game controls */
    function guardInputs(e) {
      if (!gameOpen()) return;
      var path = e.composedPath ? e.composedPath() : [e.target];
      for (var i = 0; i < path.length; i++) {
        var t = path[i];
        if (!t || !t.tagName) continue;
        if (/^(INPUT|TEXTAREA|SELECT|DIALOG|SHOPIFY-ACCOUNT)$/.test(t.tagName) || t.isContentEditable) { e.stopImmediatePropagation(); return; }
      }
    }
    window.addEventListener('keydown', guardInputs, true); window.addEventListener('keyup', guardInputs, true);

    var ctx = null;
    /* Same rule as paix-fx.js: sound is on unless the customer switched it off */
    var soundOn = read('localStorage', 'pxSound') !== 'off';
    /* The browser only lets sound start after the customer's first tap (sticky user activation) */
    function tapped() { return !navigator.userActivation || navigator.userActivation.hasBeenActive; }
    /* audio(true) may create the engine; audio() only uses one that exists (F-31: never made inside a tap or at load) */
    function audio(create) {
      if (!soundOn) return null;
      /* One shared engine with paix-fx.js (window.__pxAudio): whichever file warms it up first, the other reuses it */
      if (!ctx) ctx = window.__pxAudio || null;
      if (!ctx && !create) return null;
      if (!ctx) { var AC = window.AudioContext || window.webkitAudioContext; if (!AC) return null; try { ctx = window.__pxAudio = new AC(); } catch (e) { return null; } }
      if (ctx.state === 'suspended' && tapped()) ctx.resume();
      return ctx;
    }
    /* F-31: no engine yet. It is made one frame after the tap (so the tap is never slowed) and the waiting sounds play then.
       Not after a tap on a link that opens another page (window.__pxNavTap from paix-fx.js): that page makes its own. */
    var waiting = [];
    function soon(fn) {
      if (!soundOn || !tapped() || window.__pxNavTap) return;
      if (waiting.push(fn) > 1) return;
      requestAnimationFrame(function () {
        setTimeout(function () {
          var list = waiting; waiting = [];
          if (window.__pxNavTap || !audio(true)) return;
          list.forEach(function (f) { f(); });
        }, 0);
      });
    }
    function tone(freq, dur, type, vol, slideTo, delay) {
      var a = audio();
      if (!a) { soon(function () { tone(freq, dur, type, vol, slideTo, delay); }); return; }
      if (a.state === 'running') return play(a, freq, dur, type, vol, slideTo, delay);
      /* First tap on a warmed-up engine: it wakes up (resume) and the sound plays as soon as it is awake */
      if (a.state === 'suspended' && tapped()) a.resume().then(function () { if (a.state === 'running') play(a, freq, dur, type, vol, slideTo, delay); }, function () {});
    }
    /* Same master volume as paix-fx.js (opgave 44): one shared GainNode on the shared engine, 0.4 of the old level */
    function out(a) {
      if (!a.__pxMaster) { var g = a.createGain(); g.gain.value = 0.4; g.connect(a.destination); a.__pxMaster = g; }
      return a.__pxMaster;
    }
    function play(a, freq, dur, type, vol, slideTo, delay) {
      var t = a.currentTime + (delay || 0), o = a.createOscillator(), g = a.createGain();
      o.type = type || 'square'; o.frequency.setValueAtTime(freq, t);
      if (slideTo) o.frequency.exponentialRampToValueAtTime(slideTo, t + dur);
      g.gain.setValueAtTime(0.0001, t); g.gain.exponentialRampToValueAtTime(vol || 0.05, t + 0.01); g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
      o.connect(g).connect(out(a)); o.start(t); o.stop(t + dur + 0.02);
    }
    var sfx = {
      power: function () { tone(60, 0.5, 'sawtooth', 0.04, 220); tone(880, 0.1, 'sine', 0.02, 1760, 0.2); },
      move: function () { tone(660, 0.04, 'square', 0.03); },
      select: function () { tone(784, 0.06, 'square', 0.04); }
    };
    /* SPEED (F-31): the engine is no longer warmed up after load here. paix-fx.js warms the shared engine in idle time
       after the customer's first tap or key press, and soon() above makes it if a sound comes first. */
    function renderSound() {
      if (!soundBtn) return;
      soundBtn.setAttribute('aria-pressed', soundOn ? 'true' : 'false');
      soundLabel.textContent = soundOn ? 'SOUND: ON' : 'SOUND: OFF';
    }
    if (soundBtn) {
      renderSound();
      soundBtn.addEventListener('click', function () {
        soundOn = !soundOn; store('localStorage', 'pxSound', soundOn ? 'on' : 'off'); renderSound(); document.dispatchEvent(new CustomEvent('px:sound'));
        if (soundOn) { audio(); setTimeout(sfx.power, 30); } else if (ctx) { ctx.suspend(); }
      });
    }

    /* Cart button in the top bar: opens the arcade-styled cart drawer */
    var hud = root.querySelector('.px-arcade__hud');
    if (hud && hud.lastElementChild) {
      hud.removeAttribute('aria-hidden');
      Array.prototype.forEach.call(hud.children, function (c) { c.setAttribute('aria-hidden', 'true'); });
      var cartBtn = document.createElement('a');
      cartBtn.href = '/cart'; cartBtn.className = 'px-arcade__cart'; cartBtn.textContent = 'CART 0';
      cartBtn.style.cssText = 'color:inherit;text-decoration:none;font:inherit;letter-spacing:inherit;padding:12px 6px;margin:-12px -6px;pointer-events:auto';
      hud.replaceChild(cartBtn, hud.lastElementChild);
      var refreshCart = function () {
        fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
          cartBtn.textContent = 'CART ' + c.item_count; cartBtn.setAttribute('aria-label', 'Cart, ' + c.item_count + ' items');
        }).catch(function () {});
      };
      refreshCart();
      cartBtn.addEventListener('click', function (e) {
        var d = document.getElementById('cart-drawer');
        if (d && typeof d.open === 'function') { e.preventDefault(); d.open(); }
      });
      document.addEventListener('visibilitychange', function () { if (!document.hidden) refreshCart(); });
    }

    function toast(msg) {
      var host = root.querySelector('.px-game') || root;
      var t = document.createElement('div');
      t.setAttribute('role', 'status'); t.textContent = msg;
      t.style.cssText = 'position:absolute;left:50%;top:56px;transform:translateX(-50%);z-index:60;padding:10px 14px;font:10px/1.4 "Press Start 2P",monospace;letter-spacing:.08em;color:#02040a;background:#8cc8ff;box-shadow:0 0 0 2px #000,0 0 20px rgb(47 139 255/.8);pointer-events:none;text-align:center;max-width:90vw';
      host.appendChild(t);
      setTimeout(function () { t.remove(); }, 3600);
    }

    /* ---------- Point table (leaderboard) ---------- */
    function localBoard(score, level) {
      var list = [];
      try { list = JSON.parse(localStorage.getItem('pxScores') || '[]'); } catch (e) {}
      if (score > 0) list.push({ score: score, level: level, at: Date.now() });
      list.sort(function (a, b) { return b.score - a.score; });
      list = list.slice(0, 10);
      try { localStorage.setItem('pxScores', JSON.stringify(list)); } catch (e) {}
      return list;
    }
    var PX = "font:8px/1.6 'Press Start 2P',monospace;letter-spacing:.08em";
    function showBoard(score, level) {
      var host = root.querySelector('.px-game');
      if (!host) return;
      var old = host.querySelector('.px-board'); if (old) old.remove();
      var box = document.createElement('section');
      box.className = 'px-board';
      box.setAttribute('aria-label', 'Point table');
      box.style.cssText = 'position:absolute;top:56px;right:16px;z-index:55;width:min(290px,calc(100% - 32px));max-height:calc(100% - 72px);overflow:auto;padding:12px;background:rgb(5 12 26/.96);border:2px solid #2f8bff;box-shadow:0 0 0 2px #000,0 0 24px rgb(47 139 255/.5);font:20px/1.1 "VT323",monospace;color:#e2f0ff';
      var rec = document.createElement('p');
      rec.style.cssText = 'margin:0 0 10px;font:9px/1.6 "Press Start 2P",monospace;color:#ffd166;display:none';
      var list = document.createElement('div');
      var nameBox = document.createElement('div');
      var foot = document.createElement('div');
      foot.innerHTML = '<a href="/pages/leaderboard" style="display:block;margin:10px 0 0;' + PX + ';color:#8cc8ff">FULL LEADERBOARD &#9656;</a><p style="margin:6px 0 0;' + PX + ';color:rgb(226 240 255/.55)">TAP OUTSIDE OR PRESS ENTER TO PLAY AGAIN</p>';
      box.appendChild(rec); box.appendChild(list); box.appendChild(nameBox); box.appendChild(foot);
      var local = localBoard(score, level);
      function paint(title, rows) {
        var h = '<p style="margin:0 0 8px;font:9px/1.6 &quot;Press Start 2P&quot;,monospace;letter-spacing:.12em;color:#8cc8ff">' + title + '</p><table style="width:100%;border-collapse:collapse">';
        if (!rows.length) h += '<tr><td style="color:rgb(226 240 255/.6)">NO SCORES YET</td></tr>';
        rows.forEach(function (r) {
          var c = r.you ? 'color:#02040a;background:#8cc8ff' : '';
          h += '<tr style="' + c + '"><td style="padding:2px 4px">' + esc(r.a) + '</td><td style="padding:2px 4px;max-width:9em;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">' + esc(r.b) + '</td><td style="padding:2px 4px;text-align:right">' + esc(r.c) + '</td></tr>';
        });
        list.innerHTML = h + '</table>';
      }
      var mine = false;
      paint('YOUR TOP 10', local.map(function (r, i) {
        var you = !mine && r.score === score && Date.now() - r.at < 5000; if (you) mine = true;
        return { a: (i + 1) + '.', b: 'LVL ' + r.level, c: r.score, you: you };
      }));
      host.appendChild(box);
      function loadTop() {
        fetch(API + '/leaderboard', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
          .then(function (r) { if (!r.ok || !/json/.test(r.headers.get('content-type') || '')) throw 0; return r.json(); })
          .then(function (d) {
            var rows = d.top.map(function (r) { return { a: r.rank + '.', b: r.name || ('PLAYER ' + String(r.player).padStart(3, '0')), c: r.score, you: r.you }; });
            if (d.me && !d.top.some(function (r) { return r.you; })) rows.push({ a: d.me.rank + '.', b: myName || 'YOU', c: d.me.best, you: true });
            paint('TOP 10 THIS MONTH', rows);
            if (loggedIn && d.me && score > 0 && d.me.best === score) { rec.style.display = 'block'; rec.textContent = '★ NEW RECORD! SAVED TO THE LIST ★'; }
          }).catch(function () {});
      }
      loadTop();

      /* ---------- Put your name on the high score list ---------- */
      var myName = null;
      function nameForm(current) {
        nameBox.innerHTML = '<form style="margin:12px 0 0;padding:10px 0 0;border-top:1px dashed #2a4f86">' +
          '<label for="px-name" style="display:block;' + PX + ';color:#ffd166">' + (current ? 'CHANGE YOUR NAME' : 'ENTER YOUR NAME FOR THE HIGH SCORE LIST') + '</label>' +
          '<div style="display:flex;gap:6px;margin-top:6px"><input id="px-name" name="name" maxlength="12" autocomplete="nickname" spellcheck="false" placeholder="NEO_RIDER" value="' + esc(current || '') + '" style="flex:1;min-width:0;min-height:40px;padding:4px 8px;font:22px/1 VT323,monospace;text-transform:uppercase;color:#e2f0ff;background:#02040a;border:2px solid #2f8bff;border-radius:0">' +
          '<button type="submit" style="flex:none;min-height:40px;padding:0 10px;' + PX + ';color:#02040a;background:#2f8bff;border:2px solid #8cc8ff;cursor:pointer">SAVE &#9654;</button></div>' +
          '<p data-msg style="margin:6px 0 0;' + PX + ';color:#8cc8ff">3-12 LETTERS, NUMBERS, - OR _</p></form>';
        var f = nameBox.querySelector('form'), inp = f.querySelector('input'), msg = f.querySelector('[data-msg]'), btn = f.querySelector('button');
        f.addEventListener('submit', function (e) {
          e.preventDefault();
          btn.disabled = true; msg.textContent = 'SAVING...';
          post('/nickname', { name: inp.value }).then(function (d) {
            myName = d.nickname; showName(); loadTop();
            if (window.PaixFx) { PaixFx.play('coin'); }
          }).catch(function (err) {
            btn.disabled = false;
            msg.style.color = '#ff8fa3';
            msg.textContent = err && err.error === 'name_taken' ? 'THAT NAME IS TAKEN' : err && err.error === 'name_blocked' ? 'PICK ANOTHER NAME' : err && err.error === 'not_member' ? 'OPEN YOUR PLAYER PROFILE FIRST' : '3-12 LETTERS, NUMBERS, - OR _';
          });
        });
        if (!current) setTimeout(function () { inp.focus({ preventScroll: true }); }, 50);
      }
      function showName() {
        nameBox.innerHTML = '<p style="margin:12px 0 0;padding:10px 0 0;border-top:1px dashed #2a4f86;' + PX + ';color:#ffd166">ON THE LIST AS <b style="color:#e2f0ff;font-weight:400">' + esc(myName) + '</b> &middot; <a href="#" data-edit style="color:#8cc8ff">CHANGE</a></p>';
        nameBox.querySelector('[data-edit]').addEventListener('click', function (e) { e.preventDefault(); nameForm(myName); });
      }
      if (!loggedIn) {
        var login = document.body.dataset.pxLogin || '/account/login';
        nameBox.innerHTML = '<p style="margin:12px 0 0;padding:10px 0 0;border-top:1px dashed #2a4f86;' + PX + ';color:#ffd166">WANT YOUR NAME ON THE HIGH SCORE LIST?</p><a href="' + esc(login) + '" style="display:inline-block;margin-top:8px;padding:10px 12px;' + PX + ';color:#02040a;background:#2f8bff;border:2px solid #8cc8ff;text-decoration:none">LOG IN / JOIN FREE &#9654;</a>';
      } else {
        fetch(API + '/me', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
          .then(function (r) { if (!r.ok) throw 0; return r.json(); })
          .then(function (d) { myName = d.nickname || null; if (myName) showName(); else nameForm(''); })
          .catch(function () { nameForm(''); });
      }

      /* Clicks and typing inside the table must not restart the game */
      box.addEventListener('pointerdown', function (e) { e.stopPropagation(); });
      function guardKeys(e) { if (e.target && e.target.closest && e.target.closest('.px-board input, .px-board button, .px-board a')) e.stopImmediatePropagation(); }
      window.addEventListener('keydown', guardKeys, true); window.addEventListener('keyup', guardKeys, true);
      function dismiss(e) {
        if (e.target && e.target.closest && e.target.closest('.px-board')) return;
        if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
        box.remove(); document.removeEventListener('keydown', dismiss, true); host.removeEventListener('pointerdown', dismiss, true);
        window.removeEventListener('keydown', guardKeys, true); window.removeEventListener('keyup', guardKeys, true);
      }
      setTimeout(function () { document.addEventListener('keydown', dismiss, true); host.addEventListener('pointerdown', dismiss, true); }, 400);
    }

    /* Game points: the server decides; the browser only reports the score of a server-issued session.
       A server round is started when the player actually starts a round (Enter/Space or a tap on the game screen,
       the same inputs that start a round in paix-game.js), not when the game is opened. So a game left open never
       expires (worker v2: 30 min). A stored round older than 25 min is replaced. Works with v1 (no expiry) too. */
    var session = null, sessionAt = 0, pending = null, roundLive = false;
    var STALE_MS = 25 * 60 * 1000;
    function post(path, data) {
      return fetch(API + path, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(data || {}) })
        .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); });
    }
    function newSession() {
      session = null; pending = null;
      if (!loggedIn) return;
      sessionAt = Date.now();
      var p = post('/game/start').then(function (d) { return (d && d.session) || null; }).catch(function () { return null; });
      pending = p;
      p.then(function (id) { if (pending === p) { pending = null; session = id; } });
    }
    /* Hands over this round's session (or the request still on its way) and clears it for the next round */
    function takeSession() {
      var t = pending || Promise.resolve(session);
      pending = null; session = null;
      return t;
    }
    function isRoundStart(e) {
      if (roundLive || !gameOpen()) return false;
      var t = e.target && e.target.closest ? e.target : null;
      if (e.type === 'keydown') {
        if (e.metaKey || e.ctrlKey || e.altKey || (e.key !== 'Enter' && e.key !== ' ')) return false;
        return !(t && t.closest('button, a, input, textarea, select, .px-board'));
      }
      var wrap = root.querySelector('.px-game');
      if (!wrap || !t || !wrap.contains(t) || t.closest('.px-board, [data-exit]')) return false;
      return !t.closest('button') || !!t.closest('[data-k]');
    }
    function onRoundInput(e) {
      if (!isRoundStart(e)) return;
      roundLive = true;
      if (!loggedIn || pending) return;
      if (!session || Date.now() - sessionAt > STALE_MS) newSession();
    }
    window.addEventListener('keydown', onRoundInput, true);
    window.addEventListener('pointerdown', onRoundInput, true);
    var reasons = { daily_cap: 'DAILY ARCADE POINTS MAXED', too_short: 'PLAY LONGER TO EARN POINTS', implausible: 'SCORE NOT ACCEPTED', ok: 'SCORE MORE TO EARN POINTS' };
    root.addEventListener('paix:gameover', function (e) {
      roundLive = false;
      var score = e.detail.score, level = e.detail.level || 1;
      if (!loggedIn) { toast('LOG IN TO EARN POINTS'); showBoard(score, level); return; }
      takeSession().then(function (s) {
        if (!s) { toast('POINTS SERVER OFFLINE'); showBoard(score, level); return; }
        post('/game/finish', { session: s, score: score }).then(function (d) {
          toast(d.points > 0 ? '+' + d.points + ' POINTS (' + d.today + '/' + d.daily_cap + ' TODAY)' : (reasons[d.reason] || 'NO POINTS THIS ROUND'));
        }).catch(function () { toast('POINTS SERVER OFFLINE'); }).then(function () { showBoard(score, level); });
      });
    });

    /* Game: the script is only downloaded when someone presses GAME */
    var gameLoading = null;
    function loadGame() {
      if (window.PaixGame) return Promise.resolve();
      if (gameLoading) return gameLoading;
      gameLoading = new Promise(function (resolve, reject) {
        var s = document.createElement('script'); s.src = root.dataset.gameSrc; s.onload = resolve; s.onerror = reject; document.head.appendChild(s);
      });
      return gameLoading;
    }
    function startGame() {
      if (!root.dataset.gameSrc || gameOpen()) return;
      var pop = document.getElementById('pxd'); if (pop) pop.hidden = true;
      if (location.hash !== '#play') history.replaceState(null, '', '#play');
      loadGame().then(function () { roundLive = false; window.PaixGame.open(root); }).catch(function () {
        gameLoading = null; if (gameLink) gameLink.textContent = 'GAME OFFLINE - RETRY';
      });
    }
    root.addEventListener('paix:gameclose', function () { session = null; pending = null; roundLive = false; if (gameLink) gameLink.focus({ preventScroll: true }); });

    function finishBoot() {
      if (!root.classList.contains('is-booting')) return;
      clearTimeout(bootTimer);
      root.classList.remove('is-booting'); root.classList.add('is-booted');
      store('localStorage', 'pxBooted', '1'); store('sessionStorage', 'pxBooted', '1');
      if (location.hash === '#play') startGame();
    }
    if (root.classList.contains('is-booting')) {
      /* SPEED (opgave 37): the sound engine is only started here if the customer has already tapped the page. Browsers play no
         sound before the first tap anyway, and creating the engine took 0.5-0.8 s while the page loaded. Sound stays ON by
         default: the first sound after a tap starts it (tone() calls audio()). */
      if (soundOn && (!navigator.userActivation || navigator.userActivation.hasBeenActive)) { audio(); setTimeout(function () { sfx.power(); }, 60); }
      bootTimer = setTimeout(finishBoot, 1250);
      if (skipBtn) skipBtn.addEventListener('click', finishBoot);
      root.addEventListener('pointerdown', function (e) {
        if (root.classList.contains('is-booting') && !e.target.closest('[data-px-sound]')) { e.preventDefault(); finishBoot(); }
      });
    } else if (location.hash === '#play') {
      startGame();
    }

    function select(i, focus) {
      if (!items.length) return;
      selected = (i + items.length) % items.length;
      items.forEach(function (el, idx) { el.classList.toggle('is-selected', idx === selected); });
      if (focus) items[selected].focus({ preventScroll: true });
    }
    select(0, false);
    items.forEach(function (el, idx) {
      el.addEventListener('mouseenter', function () { if (selected !== idx) { select(idx, false); sfx.move(); } });
      el.addEventListener('focus', function () { if (selected !== idx) select(idx, false); });
      el.addEventListener('click', function (e) {
        sfx.select();
        if (el.hasAttribute('data-px-game')) { e.preventDefault(); startGame(); }
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.defaultPrevented || gameOpen()) return;
      var pop = document.getElementById('pxd'); if (pop && !pop.hidden) return;
      if (document.querySelector('dialog[open]')) return;
      var tag = (e.target && e.target.tagName) || '';
      if (/INPUT|TEXTAREA|SELECT|BUTTON/.test(tag) || (e.target && e.target.isContentEditable)) return;
      if (root.classList.contains('is-booting')) {
        if (e.key !== 'Tab' && !e.metaKey && !e.ctrlKey && !e.altKey) { e.preventDefault(); finishBoot(); }
        return;
      }
      if (e.key === 'ArrowDown' || e.key === 's' || e.key === 'S') { e.preventDefault(); select(selected + 1, true); sfx.move(); }
      else if (e.key === 'ArrowUp' || e.key === 'w' || e.key === 'W') { e.preventDefault(); select(selected - 1, true); sfx.move(); }
      else if (e.key === 'Enter' && !(document.activeElement && document.activeElement.closest('a'))) { e.preventDefault(); items[selected].click(); }
    });
  }

  function boot() { document.querySelectorAll('[data-px-arcade]').forEach(initArcade); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
